export default "__VITE_ASSET__pqSkNY$h__"